// ==========================================
// TTS chip (3a)
// ==========================================
// Sits under the message BB is reading aloud: waveform, rate, stop. 22px tall, so it
// costs nothing against the gamification chrome budget.
// ==========================================

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-buddy-tts-chip',
  standalone: false,
  templateUrl: './buddy-tts-chip.component.html',
  styleUrls: ['./buddy-tts-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuddyTtsChipComponent {
  /** Playback rate, 0.75-2x per the spec. */
  @Input() rate = 1;

  @Output() stopped = new EventEmitter<void>();

  readonly bars = [0, 1, 2, 3];

  get rateLabel(): string {
    return `${this.rate.toFixed(1)}×`;
  }
}
